import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form5({ defaultValues, ...props }: Props) {
  const { handleSubmit, errors, control } = useForm({
    defaultValues: replaceDefaultValues(
      {
        pricesAdministration: '',
        pricesTax: '',
      },
      defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Características de tu propiedad</h1>

      <FormElement
        name="pricesTax"
        label="Impuestos anuales*"
        error={errors.pricesTax}
        elementType="price"
        control={control}
        rules={{ required: true }}
      />

      <FormElement
        name="pricesAdministration"
        label="Valor de la administración"
        control={control}
        elementType="price"
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
